import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { ReactComponent as FilterIcon } from 'assets/icons/sort.svg';
import React from 'react';
import { ENUM_INBOUND_ROLE } from 'utils/enum';

type Props = {
  searchValue: string;
  setSearchValue: (item: string) => void;
  roleFilter: ENUM_INBOUND_ROLE | null;

  setRoleFilter: (item: ENUM_INBOUND_ROLE | null) => void;
};
const CSFilter = ({ searchValue, setSearchValue, setRoleFilter, roleFilter }: Props) => {
  const ROLE_LIST: { text: string; value: ENUM_INBOUND_ROLE }[] = [
    {
      text: 'inbound',
      value: ENUM_INBOUND_ROLE.CS_INBOUND
    },
    {
      text: 'outbound',
      value: ENUM_INBOUND_ROLE.CS_OUTBOUND
    },
    {
      text: 'admin',
      value: ENUM_INBOUND_ROLE.CS_ADMIN
    },
    {
      text: 'lead',
      value: ENUM_INBOUND_ROLE.CS_SUPER_ADMIN
    },
    {
      text: 'Customer service',
      value: ENUM_INBOUND_ROLE.CS
    }
  ];

  const handleFilter = (filter: ENUM_INBOUND_ROLE) => {
    if (roleFilter === filter) {
      setRoleFilter(null);
    } else {
      setRoleFilter(filter);
    }
  };
  return (
    <div className='flex items-center justify-between gap-4 flex-wrap'>
      <Dropdown
        placement='bottom-start'
        content={
          <div className='border border-[#E5E6E6] rounded-[5px] text-xs leading-[19px] px-4 py-1 flex justify-between w-[114px]  cursor-pointer'>
            <span className='text-[#5E6164]'>Filter by</span>
            <FilterIcon className={`${roleFilter ? 'text-red-5' : 'text-[#5E6164]'}`} />
          </div>
        }>
        <DropdownList>
          {ROLE_LIST.map(({ text, value }, i) => (
            <DropdownItem
              className={`capitalize ${roleFilter === value ? 'text-red-5' : ''}`}
              key={i}
              onClick={() => handleFilter(value)}>
              {text}
            </DropdownItem>
          ))}
        </DropdownList>
      </Dropdown>

      <Input
        type='search'
        className='w-[280px]'
        inputClass='h-[35px]'
        placeholder='Search '
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value.toLocaleLowerCase())}
      />
    </div>
  );
};

export default CSFilter;
